import { useContextTS } from "@inrange/utils";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useCallback } from "react";
import getExtractInvoiceUploadFields, {
  ExtractInvoiceUploadFieldsResponse,
} from "../http/getExtractInvoiceUploadFields";
import { ReloginContext } from "../ReloginContext";
import { getAuthTokenBlocking } from "./utils";

const useExtractInvoiceUploadFields = () => {
  const { getToken } = useKindeAuth();
  const { relogin } = useContextTS(ReloginContext);

  const extractUploadFields = useCallback(
    async (
      siteId: string,
      fileGuid: string,
      fileName: string,
      fileType: string
    ): Promise<ExtractInvoiceUploadFieldsResponse> =>
      getExtractInvoiceUploadFields(
        await getAuthTokenBlocking(getToken, relogin),
        siteId,
        fileGuid,
        fileName,
        fileType
      ),
    [getToken, relogin]
  );

  return { extractUploadFields };
};

export default useExtractInvoiceUploadFields;
